module.exports = __webpack_public_path__ + "3c6649037249fe3daf1984896fa794c2.png";